<template>
  <div class="extras-label-container">
    <w-nav-bar :nav_title="extrasType.replace(/:/g, '').replace(/：/g, '')" :right_btn_html="rightContent" @mobileLeftBtn="pageBack" @mobileRightBtn="saveLabel"></w-nav-bar>
    <div class="extra-content">
      <div class="extras-item flex-column">
        <span class="label">{{ extrasType }}</span>
<!--        <input v-model="extrasValue" type="text"  :placeholder="`请选择${extrasType}标签`">-->
        <w-textarea ref="extraInput" v-model="extrasValue" :placeholder="`请选择${extrasType}标签`"  :line-height="20"
                    :font-size="16" :max-length="999999" style="margin-top: 12px" @input="inputChangeValue($event)"></w-textarea>
        <div class="search-result" v-if="search && list[field].length">
          <cube-scroll :data="list[field]">
            <div>
              <div v-for="(val, index) in list[field]" :key="index" class="search-item"
                    @click="selectLabel(val)" v-html="val.highlight"></div>
            </div>
          </cube-scroll>
        </div>
      </div>
    </div>
    <template v-if="field === 'skill'">
      <template v-if="cvProfessionSkills.length">
        <div class="extras-tag-title">专业技能</div>
        <div class="extras-tags flex-start skill-tags">
          <div class="tag-item" v-for="(item, index) in cvProfessionSkills" :key="index"
              :class="{'tag-item-active': item.checked}" @click="handleClickTag(item)">
            {{ item.value }}
          </div>
        </div>
      </template>
      <div class="extras-tag-title">通用技能</div>
    </template>
    <div class="extras-tags flex-start" :class="[field === 'skill' ? 'skill-tags' : '']">
      <div class="tag-item" v-for="(item, index) in extrasTags" :key="index"
           :class="{'tag-item-active': item.checked}" @click="handleClickTag(item)">
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
  import WNavBar from '../../../components/global/w-navbar'
  import WTextarea from '../../../components/global/w-textarea'
	import { eventMixin } from '../../../assets/js/mixin/global'
  import { moduleMixin } from '../../../assets/js/mixin/cv'
  import { componentsMixin } from '@/assets/js/mixin/components'
	import tags from '../../../assets/json/editor-extras'
	import { mapState, mapMutations } from 'vuex'
  import api from '@/api/api-list'

	export default {
		name: 'edit-label',
		mixins: [ eventMixin, moduleMixin, componentsMixin ],
		data () {
			return {
				extrasTags: [], // 当前编辑的extra的tag列表
        extrasValue: '',
        separator: null, // 分隔符 中文简历 ，英文简历 ,
        field: null,
        search: false,
        list: {
          skill: [], // 技能
          language: [],
          certificate: [],
          other: [],
          interest: []
        },
        extrasType: '',
        cvProfessionSkills:[], //简历匹配的技能tag
			}
    },
		mounted () {
      this.initTags()
		},
		computed: {
			...mapState('cv', [ 'cv', 'currentInfo' ]),
			// 右侧内容
			rightContent () {
				return `<span>保存</span>`
			},
			// 当前编辑的是哪个extras
			extrasType () {
				let { type } = this.$route.query
        let { submodule_info } = this.cv
				return submodule_info[`${type}_title`]
			},
		},
		watch: {},
		components: {
			WNavBar,
      WTextarea
		},
		methods: {
			...mapMutations('cv', [ 'changeCurrentInfo' ]),
			// 当前编辑的中文
			pageBack () {
				this.$router.back()
			},
			// 初始化tags
			initTags () {
        let { type, search } = this.$route.query
        let { token } = this.$route.params
        // 类型
        this.field = type
        this.search = search
				this.extrasTags = JSON.parse(JSON.stringify(tags[type]))
        this.extrasValue = this.currentInfo[type].description ||  ''
        // 初始化分隔符
        this.separator = this.lang === 'cn' ? '，' : ','
        // 如果有值 并且最后一个值不是分隔符，则默认给它加上分隔符
        if ( this.extrasValue && (this.extrasValue.substr(this.extrasValue.length - 1, 1) !== this.separator) ) {
          this.extrasValue += this.separator
        }
        // 获取技能 tag
			  this.getCvProfessionSkills(token);
      },
      // 防抖
			inputChangeValue (e) {
        let { type } = this.$route.query
				if (this.search && !e.isComposing && type === 'skill') {
				  this.debounce(this[`${ this.field }AutoComplete`], 300)
				}
      },
      // 选择
			selectLabel (val) {
        let index = this.extrasValue.lastIndexOf(this.separator)
        let str = this.extrasValue.slice(0, index + 1) + val.name + this.separator
				this.extrasValue = str
			},
      // 技能自动补全
      async skillAutoComplete () {
        try {
          let index = this.extrasValue.lastIndexOf(this.separator)
          let query = this.extrasValue.slice(index + 1)
          if (!query) return this.list[this.field] = []
					let res = await this.$api.staticApi.skillComplete({
						keyword: query
					})
					if (res.code === 1000) {
						this.list.skill = res.data
					}
				} catch (e) {
					console.log('技能自动补全 错误', e)
				}
      },
			// 处理点击事件
			handleClickTag (item) {
				item.checked = !item.checked
				if (item.checked) {
					this.extrasValue += (item.value + this.separator)
				} else {
          // 优先匹配有分隔符的tag，如果没有，则直接匹配tag
          let str = this.extrasValue.includes(item.value + this.separator) ? (item.value + this.separator) : item.value
					this.extrasValue = this.extrasValue.replace(new RegExp(str, 'gi'), '')
        }
				this.$forceUpdate()
      },
      // 清理末尾的分隔符
      clearLastSeparator () {
        let value = this.extrasValue
        let lastValue = value && value.substr(value.length - 1, 1)
        if (lastValue === this.separator) {
          this.extrasValue = value.slice(0, value.length - 1)
        }
      },
      // 点击保存事件
      saveLabel () {
        this.clearLastSeparator()
	      let { type } = this.$route.query
        let value = {
	        ...this.currentInfo,
	        [type]: {
	        	name: this.currentInfo[type] && this.currentInfo[type].name ? this.currentInfo[type].name : this.extrasType ,
	        	id: this.currentInfo[type] && this.currentInfo[type].id ? this.currentInfo[type].id : null,
	        	description: this.extrasValue
          }
        }
	      this.changeCurrentInfo(value)
        this.$router.back()
      },
      // 获取技能 tag
			getCvProfessionSkills(token){
				api.cv.getCvProfessionSkills(token).then(res=>{
					if(res.code === 1000){
						this.cvProfessionSkills = res.data.map(value => {
							return { value }
						})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/global/variable';
  @import '../../../assets/scss/global/mixin';
  .extras-label-container {
    @include mobile-container(44px, 1px);
    .extra-content {
      padding: 26px 24px 0;
      .extras-item {
        position: relative;
        .label {
          color: $color-dark-gray;
          font-size: $font-size-small;
        }
        input {
          padding: 12px 0;
          border: none;
          border-bottom: 1px solid #EEEFF0;
          font-size: $font-size-medium-x;
          color: $color-title;
          &::placeholder {
            color: #BCBCBC;
          }
        }
      }
    }
    .extras-tag-title{
      color: #9c9c9c;
      margin: 28px 8px 0 24px;
    }
    .extras-tags {
      padding: 20px 8px 20px 24px;
      flex-wrap: wrap;
      &.skill-tags{
        padding: 8px 8px 5px 24px;
      }
      .tag-item {
        padding: 4px 12px;
        border: 1px solid #ececec;
        border-radius: 16px;
        color: #9c9c9c;
        margin-right: 12px;
        margin-top: 12px;
      }
      .tag-item-active {
        background-color: $color-theme;
        color: $color-light;
        border-color: transparent !important;
      }
    }
    .search-result {
      position: absolute;
      bottom: -170px;
      left: 0;
      background-color: $color-light;
      width: 100%;
      height: 172px;
      border: 1px solid #eeeff0;
      border-radius: 6px;
      padding: 0 16px;
      box-sizing: border-box;
      z-index: 9;
      .search-item {
        height: 32px;
        color: $color-dark-gray;
        font-size: $font-size-medium;
        line-height: 32px;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        /deep/ .es-highlighter {
          color: $color-theme;
        }
        /*width: 100%;*/
        &:first-child {
          margin-top: 6px;
        }
        &:last-child {
          margin-bottom: 6px;
        }
      }
    }
  }
</style>
